import { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { fetchSearchToken } from 'data/config/actions'

const FETCH_TOKEN_INTERVAL = 15 * 60 * 1000 // 15 min

class SearchTokenRefresh extends Component {
  componentDidMount() {
    this.props.fetchSearchToken()
    this.fetchInterval = setInterval(() => {
      this.props.fetchSearchToken()
    }, FETCH_TOKEN_INTERVAL)

    window.addEventListener('online', this.onOnline)
  }

  componentWillUnmount() {
    clearInterval(this.fetchInterval)
    window.removeEventListener('online', this.onOnline)
  }

  onOnline = () => {
    this.props.fetchSearchToken()
  }

  render() {
    return null
  }
}

export default compose(
  connect(
    null,
    { fetchSearchToken }
  )
)(SearchTokenRefresh)
